module.exports = __webpack_public_path__ + "static/img/info_stage3.2fdc3c8.png";


//////////////////
// WEBPACK FOOTER
// ./public/image/info_stage3.png
// module id = xz1m
// module chunks = 1